import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/voice')({
    head: () => ({
        meta: [
            {
                title: 'Voice Agent Lab | Phoebe Admin',
            },
        ],
    }),
});
